var _path, _path2, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorsUnlockedMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,38c-0.5517578,0-1-0.4482422-1-1V22.6572266c0-0.8017578,0.3124876-1.5556641,0.8789062-2.1220703L9.4140625,18H36v4h2V7 c0-1.6542969-1.3457031-3-3-3H22.2421875c-1.0527344,0-2.0839844,0.4267578-2.828125,1.171875L5.4648438,19.1210938 C4.5205078,20.0654297,4,21.3212891,4,22.6572266V37c0,1.6542969,1.3457031,3,3,3h19v-2H7z M20.828125,6.5859375 C21.2001953,6.2138672,21.7158203,6,22.2421875,6H35c0.5517578,0,1,0.4482422,1,1v9H11.4140625L20.828125,6.5859375z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43,32h-9v-3c0-1.6542969,1.3457031-3,3-3c1.3019409,0,2.4016113,0.838501,2.8157349,2h2.0831909 C41.4342651,25.7207031,39.4144287,24,37,24c-2.7568359,0-5,2.2431641-5,5v3h-1c-1.6542969,0-3,1.3457031-3,3v8 c0,1.6542969,1.3457031,3,3,3h12c1.6542969,0,3-1.3457031,3-3v-8C46,33.3457031,44.6542969,32,43,32z M44,43 c0,0.5517578-0.4482422,1-1,1H31c-0.5517578,0-1-0.4482422-1-1v-8c0-0.5517578,0.4482422-1,1-1h12c0.5517578,0,1,0.4482422,1,1V43z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "36,37 36,42 38,42 38,37 38,36 36,36 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorsUnlockedMedium);
export default __webpack_public_path__ + "static/media/doors-unlocked--medium.c76064e464a650e642574fd13918f355.svg";
export { ForwardRef as ReactComponent };